window.AcademyView = Backbone.View.extend({
  el: 'body',

  initialize(opts) {
    Carousel
  }
})
